import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type ImageErrorProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M12.0002 8.66658C10.1592 8.66658 8.66683 10.159 8.66683 11.9999C8.66683 13.8409 10.1592 15.3333 12.0002 15.3333C13.8411 15.3333 15.3335 13.8409 15.3335 11.9999C15.3335 10.159 13.8411 8.66658 12.0002 8.66658Z',
    'M12 10.6667L12 12',
    'M12 13.3333L11.9971 13.3333',
    'M12.688 8.56679V2.66659C12.688 1.93021 12.091 1.33325 11.3547 1.33325H2.02132C1.28494 1.33325 0.687988 1.93021 0.687988 2.66659V11.9999C0.687988 12.7363 1.28494 13.3333 2.02132 13.3333H8.80925',
    'M4.35449 6C4.90678 6 5.35449 5.55228 5.35449 5C5.35449 4.44772 4.90678 4 4.35449 4C3.80221 4 3.35449 4.44772 3.35449 5C3.35449 5.55228 3.80221 6 4.35449 6Z',
    'M11.8682 8.51386L9.35433 6L2.021 13.3333',
  ],
  '24': [
    'M18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23C20.7614 23 23 20.7614 23 18C23 15.2386 20.7614 13 18 13Z',
    'M18 16L18 18',
    'M18 20L17.9956 20',
    'M19.0317 12.8503V4C19.0317 2.89543 18.1363 2 17.0317 2H3.03174C1.92717 2 1.03174 2.89543 1.03174 4V18C1.03174 19.1046 1.92717 20 3.03174 20H13.2136',
    'M6.53174 9C7.36017 9 8.03174 8.32843 8.03174 7.5C8.03174 6.67157 7.36017 6 6.53174 6C5.70331 6 5.03174 6.67157 5.03174 7.5C5.03174 8.32843 5.70331 9 6.53174 9Z',
    'M17.8025 12.7708L14.0317 9L3.03174 20',
  ],
  '32': [
    'M23.9998 17.3334C20.3179 17.3334 17.3332 20.3182 17.3332 24.0001C17.3332 27.682 20.3179 30.6667 23.9998 30.6667C27.6817 30.6667 30.6665 27.682 30.6665 24.0001C30.6665 20.3182 27.6817 17.3334 23.9998 17.3334Z',
    'M24 21.3333L24 24',
    'M24 26.6667L23.9941 26.6667',
    'M25.3755 17.1338V5.33341C25.3755 3.86066 24.1816 2.66675 22.7088 2.66675H4.04216C2.5694 2.66675 1.37549 3.86066 1.37549 5.33341V24.0001C1.37549 25.4728 2.5694 26.6667 4.04216 26.6667H17.618',
    'M8.70898 12C9.81355 12 10.709 11.1046 10.709 10C10.709 8.89543 9.81355 8 8.70898 8C7.60441 8 6.70898 8.89543 6.70898 10C6.70898 11.1046 7.60441 12 8.70898 12Z',
    'M23.7364 17.0277L18.7087 12L4.04199 26.6667',
  ],
};

const ImageError = (props: ImageErrorProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths?.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default ImageError;
